import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import localStorageUtils from "../hooks/localStorageUtils";
import { useTranslation } from "react-i18next";
import Frame from "../components/Frame";
import { GIFT_QR, STEPS } from "../consts";
import FeedbackOverlay from "../components/FeedbackOverlay";
import QrCodeScanner from "../components/QrCodeScanner/QrCodeScanner";

export default function Finish({ sendAddStat }) {
    // const [redeemed, setRedeemed] = useState(false);
    const { t } = useTranslation();
    const [redeemed, setRedeemed] = useState(localStorageUtils.isRedeemed());
    const [showQr, setShowQr] = useState(false);
    const [scanErr, setScanErr] = useState(false);

    const handleScan = (data) => {
        if (data && data === GIFT_QR) {
            handleRedeem();
        } else {
            setScanErr(true)
            setShowQr(false);
        }
    };

    const handleRedeem = () => {
        localStorageUtils.markAsRedeemed();
        setRedeemed(true);

        if (sendAddStat) {
            sendAddStat(101, true);
        }
    };

    return (
        <>
            <Frame
                step={STEPS.FINISH}
                btn={!redeemed
                    ? {
                        wide: true,
                        hideIcon: true,
                        title: t('REDEEM'),
                        onClick: () => setShowQr(true),
                    }
                    : null
                }
            >
                <Stack
                    alignItems={'center'}
                    justifyContent='center'
                    height={'100%'}
                >
                    {!redeemed
                        ? showQr
                            ? <QrCodeScanner style={{ width: '100%', height: '100%' }}
                                onScanSuccess={(decodedText) => handleScan(decodedText)}
                            />
                            : <Stack
                                textAlign={'center'}
                                justifyContent={'space-between'}
                                height={'100%'}
                                spacing={3}
                            >
                                <Typography fontSize='1.9rem' color="white">
                                    {t('CONGRATULATIONS')}
                                </Typography>

                                <Typography fontSize='1.2rem' color="#00ff00">
                                    {t('PRIZE')}
                                </Typography>
                            </Stack>
                        : <Typography
                            color='white'
                            fontSize='1.9rem'
                        >
                            {t('ALREADY_REDEEM')}
                        </Typography>
                    }
                </Stack>
            </Frame >

            <FeedbackOverlay
                isOpen={scanErr}
                setIsOpen={setScanErr}
                message={scanErr ? t('WRONG_QR') : t('WRONG_QR')}
                isSuccess={!scanErr}
            />
        </>
    );
}